import React from "react";
import { useExpanded, useSortBy, useTable} from "react-table";
import styles from "./styles/UserTransactions.module.css"
export function UserTransactionTable({ columns, data}){
    const {
        getTableProps, 
        getTableBodyProps,
        headerGroups,
        rows, 
        prepareRow,
      }= useTable({columns,data}, useSortBy, useExpanded)
    return(
      <>
      <table {...getTableProps()} className={styles.sub_table_div}>
        <thead>
            {headerGroups.map(headerGroup => (
              <tr className={styles.head_row} {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map(column => (
                    
                  <th className={styles.th} {...column.getHeaderProps(column.getSortByToggleProps())}>
                    {console.log(column)}
                    <div className={styles.header}>
                    <span>{column.render("Header")}</span>
                        <div className={styles.sort_neutral}></div>
                    </div>
                  </th>
                  ))}
              </tr>
            ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.map((row, i) => {
              prepareRow(row);
              return (
                <React.Fragment key={row.getRowProps().key}>
                    <tr className={styles.row}>
                      {row.cells.map((cell) => {
                        console.log(cell)
                          return (
                            <td className={styles.td} {...cell.getCellProps()}{...row.getToggleRowExpandedProps({ title: undefined })}>{cell.render("Cell")}</td>
                          );
                      })
                      }
                    </tr>
                </React.Fragment>
              );
            })}
        </tbody>
    </table>
    </>
    )
}